import { useBoundStore } from '@/store';
import { UserMenuDialogType } from '../UserMenuDialog/UserMenuDialog';
import UserMenuItem from '../UserMenuItem/UserMenuItem';
import { getFlag } from '../UserMenuDialog/UserMenuDialogConfig';
import { useUserDatacenters } from '@/hooks/useUserDatacenters';

export default function UserRegion() {
  const selectedRegion = useBoundStore((state) => state.selectedRegion);
  const { userDatacenters } = useUserDatacenters();

  const hasMultipleRegionsAccess = userDatacenters && userDatacenters.length > 1;
  if (!hasMultipleRegionsAccess) return null;

  return (
    <UserMenuItem
      id="btnUserRegion"
      ariaLabel="User region selection"
      dialogType={UserMenuDialogType.UserRegion}
      icon={
        <span
          aria-hidden="true"
          className="h-full w-full"
        >
          {getFlag(selectedRegion)}
        </span>
      }
    />
  );
}
